import { useCallback, useMemo } from 'react';

import { isLongFormProjectType } from 'src/data/project';
import * as events from 'src/lib/events';
import { useTrackingEvent } from 'src/services/useTrackingEvent';

export const useEvents = ({ inPopupMode }) => {
  const trackEvent = useTrackingEvent();

  const commonAttributes = useMemo(
    () => ({
      page: events.EVENT_PAGE.homePage,
      uiComponentLocation: inPopupMode ? 'create_content_popup' : 'homepage',
    }),
    [inPopupMode]
  );

  const trackSubmit = useCallback(
    (promptText) => {
      trackEvent(events.CONTENT_CREATION.widgetSubmitted, {
        ...commonAttributes,
        prompt: promptText,
      });
    },
    [commonAttributes, trackEvent]
  );

  const trackQuickNavigation = useCallback(
    (action) => {
      trackEvent(events.CONTENT_CREATION.widgetQuickNavigation, {
        ...commonAttributes,
        actionChosen: action,
      });
    },
    [commonAttributes, trackEvent]
  );

  const trackBlankProject = useCallback(
    (projectType) => {
      trackEvent(events.CONTENT_CREATION.widgetBlankProject, {
        ...commonAttributes,
        contentType: isLongFormProjectType(projectType) ? 'long_form' : 'short_form',
      });
    },
    [commonAttributes, trackEvent]
  );

  return useMemo(
    () => ({
      trackSubmit,
      trackQuickNavigation,
      trackBlankProject,
    }),
    [trackSubmit, trackQuickNavigation, trackBlankProject]
  );
};
